import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Donutchart from '../../common/donutchart';
import Linechart from '../../common/linechart';


const Overview = () => {

    const [isSearchbar, toggleSearchBar] = useState(false);

    return (
        <>
            <div className={`overlay ${isSearchbar ? 'active' : ''}`} onClick={() => toggleSearchBar(false)}></div>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>All Events</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/events/admin/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">All Events</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-1 col-sm-12 text-right hidden-xs"></div>
                        <div className="col-md-5 col-sm-12 text-right">
                            <div className="input-group mb-3">
                                <div className='search_input_div_event'>
                                    <input type="text" className="form-control" placeholder="Search here..." />
                                    <span onClick={() => toggleSearchBar(true)} className="btn btn-outline-primary mr-1" title="">Create an Event</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row clearfix3 profile_list pt-3">
                        <div className="col-lg-3 col-md-6">
                            <Link to="/events/admin/">
                                <div className="card">
                                    <div className="body">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-in-bg bg-indigo text-white rounded-circle">
                                                <i class="fa fa-user-o" aria-hidden="true"></i>
                                            </div>
                                            <div className="ml-4">
                                                <h4 className="mb-0 font-weight-medium">Attendees</h4>
                                                <span>87</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <Link to="/events/admin/">
                                <div className="card">
                                    <div className="body">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-in-bg bg-azura text-white rounded-circle">
                                                <i class="fa fa-user-o" aria-hidden="true"></i>
                                            </div>
                                            <div className="ml-4">
                                                <h4 className="mb-0 font-weight-medium"> Guests</h4>
                                                <span>53</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <Link to="/events/admin/">
                                <div className="card">
                                    <div className="body">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-in-bg bg-orange text-white rounded-circle">
                                                <i class="fa fa-ticket"></i>
                                            </div>
                                            <div className="ml-4">
                                                <h4 className="mb-0 font-weight-medium">Tickets</h4>
                                                <span>87</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <Link to="/events/admin/">
                                <div className="card">
                                    <div className="body">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-in-bg bg-pink text-white rounded-circle">
                                                <i class="fa fa-dollar"></i>
                                            </div>
                                            <div className="ml-4">
                                                <h4 className="mb-0 font-weight-medium">Revenue in  INR</h4>
                                                <span>INR 119,001</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="row clearfix">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="body">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="mb-0">Registrations</h6>
                                        </div>
                                        <ul className="nav nav-tabs2">
                                            <li className="nav-item"><Link className="nav-link active show" data-toggle="tab"  >Today</Link></li>
                                            <li className="nav-item"><Link className="nav-link" data-toggle="tab"  >Week</Link></li>
                                            <li className="nav-item"><Link className="nav-link" data-toggle="tab" >Month</Link></li>
                                        </ul>
                                    </div>
                                    <div className="row clearfix">

                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <Linechart />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>






            </div >
        </>
    );
}
export default Overview
